module.exports = {
    JOURNEYCONTENT_GET: '/api/Content/Journey/',
    STAGE1_SUBMIT: '/api/ApplicationSubmit/Stage1',
    STAGE2_SUBMIT: '/api/ApplicationSubmit/Stage2',
    STAGE3_SUBMIT: '/api/ApplicationSubmit/Stage3',
    SESSIONID_GET: '/api/Utility/GetSessionId',
    ANNUALINCOME_PLATINUM_GET:'/api/content/AnnualIncomeForPlatinumCard',
    ANNUALINCOME_GET:'/api/content/AnnualIncome',
};
